import { render, staticRenderFns } from "./InstantCreditFormStepMailingAddress.vue?vue&type=template&id=128a33f6"
import script from "./InstantCreditFormStepMailingAddress.vue?vue&type=script&lang=js"
export * from "./InstantCreditFormStepMailingAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports